export default __webpack_public_path__ + "static/media/point.52749b0d.svg";